import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDrag, useDrop } from 'react-dnd';
import PickerTextControls from './pickerTextControls';
import Icon from '../../common/containers/icon';
const dndType = 'PICKER';
const PickerRow = _ref => {
  let id = _ref.id,
    index = _ref.index,
    name = _ref.name,
    onOrderChange = _ref.onOrderChange,
    onTextChange = _ref.onTextChange,
    onDisableToggle = _ref.onDisableToggle,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? 0 : _ref$disabled,
    editing = _ref.editing,
    onEditingStart = _ref.onEditingStart;
  const ref = useRef();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isFirstRender = _useState2[0],
    setIsFirstRender = _useState2[1];
  useLayoutEffect(() => {
    setTimeout(() => {
      setIsFirstRender(false);
    }, 500);
  }, []);
  const _useDrop = useDrop({
      accept: dndType,
      collect(monitor) {
        return {
          handlerId: monitor.getHandlerId()
        };
      },
      // Note (CF): The below code is mostly a modified example from
      // the react-dnd library.
      hover(item, monitor) {
        var _ref$current;
        if (!ref.current) {
          return;
        }
        const dragIndex = item.index;
        const hoverIndex = index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
          return;
        }
        // Determine rectangle on screen
        const hoverBoundingRect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
          return;
        }
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
          return;
        }
        // Time to actually perform the action
        onOrderChange(dragIndex, hoverIndex);
        /* eslint-disable-next-line no-param-reassign */
        item.index = hoverIndex;
      }
    }),
    _useDrop2 = _slicedToArray(_useDrop, 2),
    handlerId = _useDrop2[0].handlerId,
    drop = _useDrop2[1];
  const drag = useDrag({
    type: dndType,
    item: () => ({
      id,
      index
    }),
    canDrag: () => !editing,
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  })[1];
  const _useState3 = useState(name),
    _useState4 = _slicedToArray(_useState3, 2),
    text = _useState4[0],
    setText = _useState4[1];
  const handleChange = event => {
    setText(event.target.value);
  };
  const handleSave = () => {
    onTextChange(text);
  };
  drag(drop(ref));
  const isBrandNewElement = isFirstRender && !text;
  return /*#__PURE__*/React.createElement("tr", {
    ref: ref,
    style: {
      animation: isBrandNewElement ? 'shake 0.4s forwards' : ''
    },
    "data-handler-id": handlerId,
    "data-testid": "picker-row"
  }, /*#__PURE__*/React.createElement("td", {
    "aria-label": "picker-row-text",
    colSpan: 2
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "bars",
    className: "pr-grab-move"
  }), /*#__PURE__*/React.createElement(PickerTextControls, {
    text: text,
    autoFocus: isBrandNewElement,
    showNewChildButton: false,
    isDisabled: disabled,
    onDisableToggle: onDisableToggle,
    onSave: handleSave,
    onEdit: () => onEditingStart(index),
    onChange: handleChange,
    editing: editing
  })));
};
PickerRow.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.number,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onOrderChange: PropTypes.func.isRequired,
  onDisableToggle: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired,
  onEditingStart: PropTypes.func.isRequired
};
export default PickerRow;